import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["component"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import Form from '@/components/widget/Form';
import PieDoughnut from '@/components/widget/visualizations/PieDoughnut';
import BarChart from '@/components/widget/visualizations/BarChart';
import LineChart from '@/components/widget/visualizations/LineChart';
import StackedBarChart from '@/components/widget/visualizations/StackedBarChart';
import List from '@/components/widget/visualizations/List';
import Overview from '@/components/widget/visualizations/Overview';
import Table from '@/components/widget/visualizations/Table';
import StackedBars from '@/components/widget/visualizations/StackedBars';
import TreeMap from '@/components/widget/visualizations/TreeMap';
import Receipt from '@/components/widget/visualizations/Receipt';
import Bubble from '@/components/widget/visualizations/Bubble';
import Scatter from '@/components/widget/visualizations/Scatter';
import GaugeChart from '@/components/widget/visualizations/GaugeChart';
import RadarChart from '@/components/widget/visualizations/RadarChart';
import parseSelections from '@/utils/widget/parseSelections';
import getSectionElementId from '@/components/widget/utils/getSectionElementId';
import { getEditingSectionAttr } from '@/components/Editor/hooks/useEditingAreas';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const SUPPORTED_SECTIONS = {
  Form,
  Questionnaire: Form,
  // DEPRECATED
  BarChart,
  StackedBarChart,
  LineChart,
  PieDoughnut,
  StackedBars,
  List,
  Overview,
  Table,
  TreeMap,
  Receipt,
  Bubble,
  Scatter,
  GaugeChart,
  RadarChart
};

function EmptyComponent() {
  return /*#__PURE__*/_jsx("div", {
    children: "Unknown Component"
  });
}

const LayoutSection = _ref => {
  let {
    id,
    className,
    editing = false,
    disabled = false,
    selected,
    widgetId,
    reportingWidgetId,
    widgetElementId,
    index,
    data,
    onCtaClick,
    showCta = false,
    workbookUrl,
    workbook,
    workbookMeta,
    isMediumContainer,
    isLargeContainer
  } = _ref;

  const {
    component
  } = data,
        componentProps = _objectWithoutProperties(data, _excluded);

  const CurrentComponent = SUPPORTED_SECTIONS[component] || EmptyComponent; // Parse stored config attributes

  const config = componentProps && componentProps.config || {};

  if (typeof config.selections === 'string') {
    config.selections = parseSelections(config.selections);
  }

  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    id: getSectionElementId({
      widgetId,
      sectionId: id
    }),
    className: clsx(className || '', editing ? styles['section--isSelectable'] : '', editing && selected ? styles['section--selected'] : '')
  }, editing && {
    [getEditingSectionAttr()]: id
  }), {}, {
    children: /*#__PURE__*/_jsx(CurrentComponent, _objectSpread(_objectSpread({}, componentProps), {}, {
      editing: editing,
      disabled: disabled,
      sectionId: id,
      widgetId: widgetId,
      widgetElementId: widgetElementId,
      reportingWidgetId: reportingWidgetId,
      sectionsIndex: index,
      onCtaClick: onCtaClick,
      showCta: showCta,
      workbookUrl: workbookUrl,
      workbook: workbook,
      workbookMeta: workbookMeta,
      isMediumContainer: isMediumContainer,
      isLargeContainer: isLargeContainer
    }))
  }));
};

export default LayoutSection;